export default __webpack_public_path__ + "static/media/forestly-expl-dissect-02_EN.910dabe6.png";